// 🔧 social_generator.js
// ✅ Purpose: Generates Social Engine demo draft posts
// ✅ Features:
// - Generates before/during/after event social drafts
// - Adapts drafts to selected add-ons in DemoContext
// - Creates platform-ready captions and hashtags
// - No Firestore writes
// - No DemoContext mutation
// - Fully block-commented for clarity and future devs

import { buildSocialDefaults } from "./templates/social_defaults";

export const generateSocial = ({ demoContext } = {}) => {
  console.log("📣 Social Generator started.");

  const industryTemplate =
    demoContext?.industryTemplate?.key ||
    demoContext?.demoConfig?.industry ||
    "car_show";

  const demoSize =
    demoContext?.demoConfig?.size ||
    demoContext?.seedProfile?.demoSize ||
    "medium";

  const socialData = buildSocialDefaults({
    industryTemplate,
    demoSize,
    demoContext,
  });

  console.log("✅ Social Generator completed.", {
    posts: socialData.posts.length,
    industryTemplate,
    demoSize,
  });

  return socialData;
};
